import {Component, Input, Output, EventEmitter, OnInit} from 'ng-metadata/core';
import './author.component.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentAuthor
 * @module mw.components.contentDocuments
 *
 * @param {string} [text] - Author name/description.
 * @param {string} [url] - The url.  If provided this will make the entire author name a clickable href.
 * @param {expression} [on-click] - Angular expression to evaluate on click of the title. $event is the ng-click event.
 *
 * @description
 * `<mw-content-document-author>` provides a means for displaying the name of a document author.
 *
 * @usage
 * <hljs hljs-language="html">
 *
 *   <!-- Using 'text' input binding -->
 *   <mw-content-document-author text="Bill Simmons"></mw-content-document-author>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-content-document-author',
    template: `
        <a class="mw-content-document-author" data-tracking-event="documentOperation/open" ng-if="::$ctrl.url" ng-href="{{::$ctrl.url}}" target="{{$ctrl.isExternalUrl() ? '_blank' : '_self'}}" ng-click="$ctrl.onAuthorClick($event);" ng-bind-html="::$ctrl.text"></a>
        <span class="mw-content-document-author" ng-if="::!$ctrl.url" ng-bind-html="::$ctrl.text"></span>
    `,
    legacy: {
        transclude: true
    }
})
export class AuthorComponent implements OnInit {
    @Input('<') text: string;
    @Input('<') url: string;
    @Output() onClick = new EventEmitter<ng.IAngularEvent>();

    constructor() {
        'ngInject';
    }

    ngOnInit() {
    }

    handleAuthorClick(event: ng.IAngularEvent) {
        this.onClick.emit(event);
    }

    isExternalUrl() {
        const host = window.location.hostname;

        const linkHost = function (url) {
            if (/^https?:\/\//.test(url)) { // Absolute URL.
                const parser = document.createElement('a');
                parser.href = url;

                return parser.hostname;
            } else { // Relative URL.
                return window.location.hostname;
            }
        }(this.url);

        return host !== linkHost;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/author/author.component.ts